import React from "react";
import Reveal from "./Reveal";

const TIERS = [
  {
    name: "AI Native",
    hours: "8 hours",
    promise: "Know AI",
    audience: "Anyone",
  },
  {
    name: "AI Builder",
    hours: "40 hours (+10)",
    promise: "Build with AI",
    audience: "Function pros, students",
  },
  {
    name: "AI Leader",
    hours: "110 hours (+20)",
    promise: "Lead with AI",
    audience: "Executives, specialists",
  },
];

const PILLARS = [
  { id: "P01", title: "AI Foundations", scope: "Literacy, prompting, and personal AI productivity." },
  { id: "P02", title: "AI Builders", scope: "Build apps, agents, and AI-powered products." },
  { id: "P03", title: "AI at Work (Functions)", scope: "Sales, marketing, HR, finance, legal — applied AI." },
  { id: "P04", title: "AI for Industry", scope: "Healthcare, manufacturing, government — vertical depth." },
  { id: "P05", title: "AI Leadership", scope: "Strategy, governance, ethics, and transformation." },
  { id: "P06", title: "AI Specializations", scope: "Deep tracks for specialists and certified experts." },
];

export default function Method() {
  return (
    <section id="method" className="py-10 md:py-14 border-t hairline" data-testid="method-section">
      <div className="container-edge">
        <Reveal>
          <p className="section-number">02 — THE METHOD</p>
        </Reveal>
        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <Reveal>
              <h2
                className="font-display text-[40px] sm:text-[52px] lg:text-[68px] leading-[0.95] tracking-tight"
                style={{ fontWeight: 500 }}
              >
                The <em className="italic grad-brand-text" style={{ fontWeight: 500 }}>Practitioner Method</em><sup className="text-[40%] align-top ml-1">™</sup>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <Reveal delay={120}>
              <p className="text-[17px] md:text-[20px] leading-relaxed" style={{ color: "var(--ink-secondary)" }}>
                A proprietary three-tier journey that turns AI curiosity into AI leadership.
                Built across six pillars. Designed for four audiences. Every certification ends
                in a shippable artifact.
              </p>
            </Reveal>
          </div>
        </div>

        {/* 3-Tier Ladder */}
        <Reveal delay={200}>
          <div className="mt-12 relative">
            <div
              className="absolute top-[42px] left-[12%] right-[12%] h-px hidden md:block"
              style={{ background: "var(--border-strong)" }}
            />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 relative">
              {TIERS.map((t, i) => (
                <div key={t.name} className="text-center md:text-left relative" data-testid={`tier-${i + 1}`}>
                  <div className="relative">
                    <div
                      className="mx-auto md:mx-0 w-[22px] h-[22px] rounded-full grad-brand"
                      style={{ boxShadow: "0 0 0 6px var(--canvas)" }}
                    />
                  </div>
                  <h3
                    className="mt-8 font-display text-[28px] md:text-[32px] tracking-tight"
                    style={{ fontWeight: 500 }}
                  >
                    {t.name}
                  </h3>
                  <p className="mt-2 font-mono text-[12px]" style={{ color: "var(--accent-gold)", letterSpacing: "0.12em" }}>
                    {t.hours.toUpperCase()}
                  </p>
                  <p className="mt-3 font-display italic text-[20px]" style={{ fontWeight: 400 }}>
                    "{t.promise}"
                  </p>
                  <p className="mt-2 text-[14px]" style={{ color: "var(--ink-secondary)" }}>
                    {t.audience}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        {/* 6 Pillars */}
        <Reveal delay={320}>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--border-soft)] border hairline">
            {PILLARS.map((p) => (
              <div
                key={p.id}
                className="p-7 bg-canvas hover:bg-white transition-colors"
                data-testid={`pillar-${p.id.toLowerCase()}`}
              >
                <p className="mono-label-gold">{p.id}</p>
                <h4 className="mt-3 font-display text-[22px] tracking-tight" style={{ fontWeight: 500 }}>
                  {p.title}
                </h4>
                <p className="mt-3 text-[14px]" style={{ color: "var(--ink-secondary)" }}>
                  {p.scope}
                </p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
